(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icons-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function IconsSlider(grid) {
      this.grid = grid;
      this.items = grid.querySelectorAll('.icons-with-text__item');
      this.current = 0;
      this.timer = null;
      this.init();
    }

    IconsSlider.prototype.isMobile = function () {
      return window.matchMedia('(max-width: 767px)').matches;
    };

    IconsSlider.prototype.init = function () {
      var self = this;
      if (self.isMobile()) self.start();
      window.addEventListener('resize', function () {
        if (self.isMobile()) {
          self.start();
        } else {
          self.stop();
        }
      });
    };

    IconsSlider.prototype.start = function () {
      if (this.timer) return;
      var self = this;
      this.timer = setInterval(function () { self.advance(); }, 3000);
    };

    IconsSlider.prototype.stop = function () {
      clearInterval(this.timer);
      this.timer = null;
      this.current = 0;
      this.grid.scrollTo({ left: 0, behavior: 'instant' });
    };

    IconsSlider.prototype.advance = function () {
      this.current = (this.current + 1) % this.items.length;
      var itemWidth = this.grid.offsetWidth;
      this.grid.scrollTo({ left: this.current * itemWidth, behavior: 'smooth' });
    };

    function initSliders() {
      document.querySelectorAll('.icons-with-text-section .icons-with-text__grid').forEach(function (grid) {
        new IconsSlider(grid);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliders);
    } else {
      initSliders();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
